import { render, staticRenderFns } from "./orderDiscountTooltip.vue?vue&type=template&id=bee76bd2&scoped=true"
import script from "./orderDiscountTooltip.vue?vue&type=script&lang=js"
export * from "./orderDiscountTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee76bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bee76bd2')) {
      api.createRecord('bee76bd2', component.options)
    } else {
      api.reload('bee76bd2', component.options)
    }
    module.hot.accept("./orderDiscountTooltip.vue?vue&type=template&id=bee76bd2&scoped=true", function () {
      api.rerender('bee76bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/orderDiscountTooltip.vue"
export default component.exports